const styles = theme => ({
  root: {
    position: 'relative',
    marginLeft: 'calc(50% - 13px)',
    alignItems: 'center',
    marginTop: '55%',
    [theme.breakpoints.up('sm')]: {
      marginTop: '40%',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '25%',
    },
  },
  textStyling: {
    position: 'relative',
    color: 'black',
    textAlign: 'center',
    alignItems: 'center',
    marginTop: 25,
    padding: 24,
    marginLeft: '-92%',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Loader/styles.js